module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "w-full cont"
  }, [_c('sy')], 1), _vm._v(" "), _c('div', {
    staticClass: "w-full cont"
  }, [_c('div', {
    staticClass: "warnmsg",
    staticStyle: {
      "text-align": "center",
      "font-size": "13px",
      "font-weight": "bold",
      "padding": "30px"
    }
  }, [_c('versionReminder')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "w-full footer-bg",
    staticStyle: {
      "height": "140px",
      "padding-top": "28px"
    }
  }, [_c('div', {
    staticClass: "f_14",
    staticStyle: {
      "width": "78%",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "demo",
    attrs: {
      "flex": "main:justify"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.footlogo) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.footlogo,
      "height": "77"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "15px",
      "line-height": "24px"
    }
  }, [_c('div', [_vm._v("热线电话：" + _vm._s(_vm.sysparam.hottel ? _vm.sysparam.hottel.sysparambeg : ''))]), _vm._v(" "), _c('div', [_vm._v("Email：" + _vm._s(_vm.sysparam.email ? _vm.sysparam.email.sysparambeg : ''))]), _vm._v(" "), _c('div', [_vm._v("地址：" + _vm._s(_vm.sysparam.address ? _vm.sysparam.address.sysparambeg : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "right",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [(_vm.qrimg) ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.qrimg,
      "height": "77"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "15px",
      "line-height": "24px"
    }
  }, [_c('div', [_c('span', {
    on: {
      "click": _vm.link
    }
  }, [_vm._v(_vm._s(_vm.sysparam.webcode ? _vm.sysparam.webcode.sysparambeg : ''))])]), _vm._v(" "), _c('div', [_vm._v("版权所有：" + _vm._s(_vm.sysparam.copyright ? _vm.sysparam.copyright.sysparambeg : ''))])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-3600b0fc!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/web/WebFooter.vue
// module id = 296
// module chunks = 0